// extracted by mini-css-extract-plugin
export default {"container":"FormInput_container__dSNLj","box":"FormInput_box__4y5Sx","link":"FormInput_link__V8Skd"};